module.exports = __webpack_public_path__ + "img/icon_sm_xqgl.970997f1.png";